export default __webpack_public_path__ + "3978cb3d4cfc9c74133473b518c419bc.png";